module.exports = __webpack_public_path__ + "assets/7ce7078da98f2831ab511ebd2ad21b26.svg";